import sistema from '../../../sistema.json';

/**
 * Nome do sistema exibido nas telas, lido do sistema.json da raiz do repositório (a identidade
 * de cada sistema feito a partir da base). Nos textos traduzidos, aparece como {{sistema}}.
 */
export const SISTEMA_NOME: string = sistema.nome;
